export default __webpack_public_path__ + "static/media/ema-jhon.39e86407.png";